import { animate, scroll, inView, stagger, spring } from 'motion';

// UTILITY FUNCTIONS ================================
// reverse an array (e.g. [1,2,3] becomes [3,2,1])
function reverseArray(arr) {
  var newArray = [];
  for (var i = arr.length - 1; i >= 0; i--) newArray.push(arr[i]);
  return newArray;
}
// invert a number (e.g. 1 becomes -1) for use in animations
function invertNumber(num) {
  return num * -1;
}


// SPRINKLE TEXT ================================
// get inner contents of elem
// split into array of characters
// map each character to a span with the character as the innerText
// animate each span
function sprinkle_text(elem) {
  // console.log(elem.innerText)
  animate(elem, { opacity: [0,1], y: [20,0] }, {});
  const elemText = elem.innerText;
  const elemTextArray = elemText.split('');
  const elemTextArrayWithSpans = elemTextArray.map(char => {
    if(char === ' ') {
      char = '</span><span>&nbsp;</span><span>';
    } else {
      char = '<span>'+char+'</span>';
    }
    return char;
  });
  elem.innerHTML = `
    <span style="display: flex; flex-wrap: wrap;">
      <span>${elemTextArrayWithSpans.join('')}</span>
    </span>`;
  animate(
    elem.querySelectorAll('span'),
    { opacity: [0,1], x: [30,0] },
    { delay: stagger(0.015, { start: 0.2 }), duration: 0.5, easing: spring() }
  );
}


// SCROLL INTO VIEW ================================
// get section with [data-animate-id="unique-section-id"]
// animate all child_selector elements within that section
// animate_each_time: true or false (default: false)
// -- if true, animate each time the section is scrolled into view
// -- if false, animate only once when the section is scrolled into view
const section_scroll_into_view = (animate_id, child_selector, animate_each_time, overrides_animation, overrides_timing ) => {
  const parent_selector = document.querySelector('[data-animate-id="'+animate_id+'"]');
  let animation_properties = { y: [40, 0], x: [20, 0], opacity: [0,1] };
  if (overrides_animation) animation_properties = Object.assign(animation_properties, overrides_animation);
  let timing_properties = { delay: stagger(0.08, {start: 0.5}) };
  if (overrides_timing) timing_properties = Object.assign(timing_properties, overrides_timing);
  if(parent_selector) {
    animate(
      parent_selector,
      { opacity: [0,1] },
      { duration: 0.5, easing: 'ease-in' }
    );
    if (!child_selector) return;
    inView('[data-animate-id="'+animate_id+'"]', ({ target }) => {
      const controls = animate(
        target.querySelectorAll(child_selector),
        animation_properties,
        timing_properties
      );
      //if(animate_each_time) return (leaveInfo) => controls.stop();
      // console.log(child_selector)
    });
  } // end of if(parent_selector)
};


// ANIMATE CHILDREN ================================
// (similar to section_scroll_into_view, but with more customization)
// animate children of a parent element (e.g. animate_children('.parent', '.child', 20, 0, 0, 0.2, 'in-view'))
// method: 'in-view' or 'scroll' (default: 'in-view')
function animate_children(parent, selector, y, x, rotate, delay, method) {
  if(!parent || !selector) return;
  // in-view based: ________________________________
  if(method === 'in-view') {
    inView(
      parent,
      ({ target }) => {
        const controls = animate(
          target.querySelector(selector),
          { opacity: [0,1], y: y, x: x, rotate: rotate},
          { delay: delay, easing: [0.22, 1, 0.36, 1], duration: 1.2, opacity: { duration: 0.5 } }
        ); // end of animate
        return (leaveInfo) => reverse_controls.play();
      },
      { amount: 0.8 }
    );
  } else {
    // scroll based: ________________________________
    scroll(
      animate(
        parent.querySelector(selector),
        { opacity: [1,1], y: y, x: x, rotate: rotate},
        { delay: delay, easing: [0.22, 1, 0.36, 1], duration: 1.2 }
      ),
      {
        target: parent.querySelector(selector),
        offset: ['start end', 'start 0.20']
      }
    ); // end of scroll
  }
}


export { reverseArray, animate_children, sprinkle_text, invertNumber, section_scroll_into_view };
